import type { LiveQuery } from './types';

/**
 * @desc A tRPC/TanStack query result narrowed to the shared {@link LiveQuery} shape (the trunk's,
 * `isLoading`). Structural, so the data layer does not depend on the client's types and a test can
 * hand a hook a plain object; TanStack v5 says `isPending`, so both spellings are read.
 */
export const liveQuery = <T>(query: {
  data?: T | undefined;
  isPending?: boolean;
  isLoading?: boolean;
  error?: { message: string } | null;
}): LiveQuery<T> => ({
  data: query.data,
  isLoading: Boolean(query.isPending ?? query.isLoading),
  error: query.error ? { message: query.error.message } : null,
});
